import { Icon } from '@/components';
import { type CustomIconName } from '@/components/Icon/Icon';
import { type Icon as FeatherIcon } from 'react-feather';
import { Link, type To } from 'react-router-dom';
import classes from './MenuItem.module.css';

type BaseMenuItemProps = {
  selected?: boolean;
  label: string;
  internal?: boolean;
} & ({ to: To; onClick?: never } | { onClick?: () => void; to?: never });

type MenuItemProps =
  | (BaseMenuItemProps & { name: CustomIconName; Component?: never })
  | (BaseMenuItemProps & { Component: FeatherIcon; name?: never });

export const MenuItem = ({
  Component,
  name,
  selected = false,
  ...props
}: MenuItemProps) => {
  const className = `${classes.button} ${
    selected ? classes.buttonSelected : ''
  }`;
  const content = (
    <>
      {Component && (
        <Icon
          Component={Component}
          size={16}
          color="currentColor"
          strokeWidth={2.5}
        />
      )}
      {name && (
        <Icon name={name} size={16} color="currentColor" strokeWidth={2.5} />
      )}
      <span
        className={`${classes.label} ${selected ? classes.labelSelected : ''}`}
      >
        {props.label}
      </span>
    </>
  );

  if (props.to) {
    return (
      <Link
        to={props.to}
        className={className}
        data-text={props.label}
        data-selected={selected}
      >
        {content}
      </Link>
    );
  }

  return (
    <button
      className={className}
      onClick={props.onClick}
      data-text={props.label}
      data-selected={selected}
    >
      {content}
    </button>
  );
};
